module.exports = __webpack_public_path__ + "img/NO937891512.beeff796.png";